const state = {
  active: false,
  config: {},
};

const mutations = {
  CHANGE_MBCIWD_ACTIVE(state, a) {
    state.active = a;
  },
  CHANGE_MBCIWD_CONFIG(state, a) {
    state.config = a;
  },
};
const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  mbciwdActive: (state) => {
    return state.active;
  },
  mbciwdConfig: (state) => {
    return state.config;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
